import { Module, VuexModule, Mutation } from "vuex-module-decorators";
import { ISelfDisclosure } from "@/selfdisclosure.interfaces";

/**
 * @returns {ISelfDisclosure}
 * @description
 * Default values for state
 */
function stateDefaults(): ISelfDisclosure {
    return {
        type: "",
        gender: "",
        firstName: "",
        lastName: "",
        phone: "",
        birthday: "",
        birthName: "",
        birthPlace: "",
        nationality: "",
        birthCountry: "",
        civilStatus: "",
        street: "",
        streetNumber: "",
        zipCode: "",
        city: "",
        region: null,
        country: "",
        residingSince: "",
        occupationType: "",
        employer: "",
        employmentSince: "",
        monthlyNetIncome1: 0,
        monthlyNetIncome2: 0,
        monthlyNetIncome3: 0,
        monthlyNetIncomePartner: 0,
        monthlyIncomeRenting: 0,
        monthlyIncomeOther: 0,
        iban: "",
        bic: "",
        bank: ""
    };
}

@Module({ namespaced: true, name: "SelfDisclosurePersistedStore" })
export default class SelfDisclosurePersisted extends VuexModule {
    selfDisclosure: ISelfDisclosure = stateDefaults();

    @Mutation
    setData(selfDisclosure: ISelfDisclosure) {
        this.selfDisclosure = { ...this.selfDisclosure, ...selfDisclosure };
    }

    @Mutation
    reset() {
        this.selfDisclosure = { ...this.selfDisclosure, ...stateDefaults() };
    }
}
